import { render, staticRenderFns } from "./NonPharmaceuticals.vue?vue&type=template&id=5ca3420c&"
import script from "./NonPharmaceuticals.vue?vue&type=script&lang=js&"
export * from "./NonPharmaceuticals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports